const FUNCTION_URL = 'https://commonops.azurewebsites.net/api/commonOps?code=uqF/kK3fJRw2oXtzPhjioHbKDqTP7YOKEnseqamnqu7pNJp2Ln570Q=='

module.exports = {
  FUNCTION_URL
};